import type { AttentionItem } from '../../domain/types';

export function slackAccentStripBackground(st: AttentionItem['st']): string {
  if (st === 'you') return 'var(--z-warn)';
  if (st === 'ready') return 'var(--z-ok)';
  return 'var(--z-dim)';
}

export function slackCardHighlighted(
  isSelected: boolean,
  isMergeSelected: boolean,
  isInMerge: boolean,
): boolean {
  return isSelected || isMergeSelected || isInMerge;
}

export function slackArticleBackground(highlighted: boolean): string {
  return highlighted ? 'var(--z-accent-wash)' : 'var(--z-surface)';
}

export function slackArticleShadow(highlighted: boolean): string {
  return highlighted ? '0 4px 16px var(--z-sh-6)' : '0 1px 2px var(--z-sh-4)';
}
